import { Box, Typography } from '@mui/material';
import React, {
  useCallback, useContext, useMemo, useState,
} from 'react';
import useForm from 'Shared/Hooks/useForm';
import ReferencialContext from 'Shared/ReferencialContext';
import AutoCompleteCmp from 'Shared/Select/AutoCompleteCmp';
import EnhancedTable from 'Shared/EnhancedTable';
import { toast } from 'react-toastify';
import GlobalLoader from 'Shared/GlobalLoader/GlobalLoader';
import { format } from 'date-fns';
import RangeDate from 'Shared/RangeDate';
import { OrderDetail } from 'Components/Orders/SageOrders/SageOrders';
import ProductSearch from 'Shared/Header/ProductSearch';
import NodataMessage from 'Components/ExternSearch/NodataMessage';
import { columnsSAV2 } from './constants';
import { mapOrderStatus } from '../Orders/constants';
import Stocks, { SelectedProduct } from './Stocks';
import { getOrders } from '../PaymentServices';
import { mapStatusRegelement } from '../AttachInvoicesPayment/constants';

const InteroProduit = () => {
  const {
    state: {
      referencial: { products, clients },
    },
  } = useContext(ReferencialContext);
  const [openDetail, setOpenDetail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [order, setOrder] = useState(null);
  const [orderNumber, setOrderNumber] = useState(null);
  const [orders, setOrders] = useState({ content: [] });
  const { values, onChange } = useForm({ product: null });
  const onChangeSelect = (name, value) => {
    onChange({ target: { value, name } });
  };
  const onChangeDate = (value, isStartDate) => {
    onChange({ target: { value, name: isStartDate ? 'startDate' : 'endDate' } });
  };

  const getOrderList = useCallback(
    async (sort) => {
      if (!values.product) {
        return;
      }
      try {
        setLoading(true);
        const data = await getOrders(
          sort,
          {
            reference: values.product?.id,
            client: values.client?.code ? [values.client?.code] : null,
            startDate: values.startDate
              ? format(
                values.startDate instanceof Date
                  ? values.startDate : new Date(values.startDate),
                'yyyy-MM-dd',
              )
              : undefined,
            endDate: values.endDate
              ? format(
                values.endDate instanceof Date
                  ? values.endDate : new Date(values.endDate),
                'yyyy-MM-dd',
              )
              : undefined,

          },
        );
        setOrders(data);
      } catch (e) {
        toast.error(e.message);
      } finally {
        setLoading(false);
      }
    },
    [values],
  );

  const handleSelectOrder = (o) => {
    setOrder(o);
    setOrderNumber(o.reference);

    setOpenDetail(true);
  };
  const salesOrders = useMemo(
    () => orders.content.map((o, index) => ({
      ...o,
      id: index,
      amountTTC: o.details
        .reduce((prev, curr) => prev + curr.montantTtc, 0)
        ?.toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$& '),
      amountHT: o.details
        .reduce(
          (prev, curr) => prev + (curr.prixUnitaire * curr.quantity * (100 - curr.remise)) / 100,
          0,
        )
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$& '),
      client: `${o.client?.code}: ${o.client?.name}`,
      paymentMode: o.paymentMode?.name,
      expedition: o.expedition?.name,
      expeditionNum: o.numExpedition,
      commercial: `${o.details[0]?.commercial?.firstName} ${o.details[0]?.commercial?.lastName}`,
      city: o.client?.city,
      noColor: o.noAnomaly,
      orange: o.quantityDifference || o.priceAndDiscountDifference,
      red: o.falseReference,
      greeen: o.paymentModeChange || o.expeditionModeChange || o.expeditionmodeChange,
      statusP: o.reglementStatus && mapStatusRegelement[o.reglementStatus]?.label,
      statusO:
          mapOrderStatus[o.status && o.status.status ? o.status.status : 'NON_ASSIGNEE']?.label,
      // statusClass:
      //    classes[
      //      mapOrderStatus[o.status && o.status.status ? o.status.status : 'NON_ASSIGNEE'].class
      //    ],
      targetProduct: o.details.find((d) => d.product.reference === values.product?.id) || {},
      click: () => handleSelectOrder(o),
    })),
    [orders],
  );

  const isNoResultAfterSearch = !loading && values.product && orders?.totalElements === 0;

  return (
    <Box>
      {loading && <GlobalLoader size="100vh" />}
      <Typography sx={{ font: 'normal normal 600 29px Montserrat', mb: 1.2 }}>
        Interrogation par produit
      </Typography>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        // background: '#E9EBED 0% 0% no-repeat padding-box',
        marginTop: 1.5,
        marginBottom: 2,
        // borderRadius: '12px 12px 0px 0px',
      }}
      >
        {!values.product ? (
          <ProductSearch
            search={values.product}
            catalog={products || []}
            handleInputChange={(e, value) => onChangeSelect('product', value)}
          />
        ) : <SelectedProduct product={values.product} />}
        <Stocks product={values.product} />
      </Box>
      {values.product && (
      <Box
        style={{
          display: 'flex',
          padding: 10,
          alignItems: 'center',
          background: '#E9EBED',
          // borderRadius: '0px 0px 12px 12px',
          borderRadius: 12,
          marginBottom: 16,
        }}
      >
        <AutoCompleteCmp
          options={clients || []}
          onChange={(e, value) => onChangeSelect('client', value)}
          value={values.client}
          getOptionLabel={(option) => `${option.code} : ${option.name}`}
          filterOptions={(options, v) => options.filter(
            (option) => option.name?.toLowerCase().includes(v.inputValue.toLowerCase())
                  || option.code?.toLowerCase().includes(v.inputValue.toLowerCase()),
          )}
          label="Client"
          isPrimaryTheme
          style={{ width: '100%' }}
        />
        <RangeDate
          value={{ start: values.startDate, end: values.endDate }}
          handleChange={onChangeDate}
          text={{ start: 'Début', end: 'Fin' }}
          // noMarginRightEnd
          styleInput={{ marginRight: '5px', width: '100%', maxWidth: 'none' }}
        />
      </Box>
      )}
      <OrderDetail
        orderNumber={orderNumber}
        open={openDetail}
        setOpen={setOpenDetail}
        order={order}
        viewOnly
      />

      {!values.product && (
        <Box style={{ width: '100%' }}>
          <Typography sx={{
            font: '600 18px Montserrat',
            color: 'rgb(56, 72, 92)',
            margin: '58px auto auto',
            textAlign: 'center',
          }}
          >
            Veuillez sélectionner un produit
          </Typography>
        </Box>
      )}
      {values.product && (isNoResultAfterSearch ? <NodataMessage message="Aucun document de vente n’a été trouvé , veuillez essayez un autre produit" /> : (
        <EnhancedTable
          getData={getOrderList}
          rows={salesOrders}
          headCells={columnsSAV2}
          count={orders.totalElements}
          rowsPerPageOptions={[10, 15, 20]}
        />
      )) }
    </Box>
  );
};
export default InteroProduit;
